var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-chips-input", {
    attrs: { value: _vm.ipList },
    on: { clear: _vm.handleClear, input: _vm.handleInput }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }